export default {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};
